import React, {useContext, useState} from 'react'
import {Card, CardBody, CardFooter, Row, Col, Button, ButtonGroup} from 'reactstrap'
import icon from '../../assets/img/icons/drip-icon.png'
import {Context as AuthContext} from '../../context/AuthContext'
import DripApiKeyModal from './DripApiKeyModal'

export default function DripConnection() {
  const authContext = useContext(AuthContext);
  const {createDripAccount, deleteDripAccount} = authContext;
  const {drip_accounts} = authContext.state;
  const buttonLabel = drip_accounts.length > 0 ? "Update" : "Connect"
  const [modal, setModal] = useState(false);

  // onclick then open a modal
  // 1. modal ask user to change the token, or delete the connection
  // TODO
  // because we do allow multiple connection, maybe having a list of token in the future

  const handleOnClick = () => {
    setModal(true);
  }

  const toggleModal = () => {
    setModal(!modal)
  }

  const handleDelete = () => {
    // for now, we only have one account per user
    // TODO: allow user to pick which account to delete
    const id = drip_accounts[0]?.id;
    deleteDripAccount(id)
  }

  return (
    <>
    <DripApiKeyModal isOpen={modal} toggleModal={toggleModal}/>
    <Card>
      <CardBody className="text-center">
        <div className="card-avatar avatar avatar-lg mx-auto">
          <img src={icon} alt="Drip Connection" className="avatar-img rounded"/>
        </div>
        <h2 className="mb-3">Drip</h2>
        {/* <Button name="mailerlite-learn-more" size="sm" color="primary" target="_blank" href={`${process.env["REACT_APP_LANDING_PAGE"]}/mailerlite-podcast-integration`}>Learn more</Button> */}
      </CardBody>
      <CardFooter className="card-footer-boxed">
        {drip_accounts.length === 0 &&
          <Row className="align-items-center justify-content-between">
            <div className="col-auto">
              <span className="text-secondary">●</span> Not Connect
            </div>
            <div className="col-auto">
              <Button name="connect" size="sm" color="primary" onClick={handleOnClick}>Connect</Button>
            </div>
          </Row>
        }
        {drip_accounts.length > 0 && <div style={{display: 'flex', flexDirection: "column", gap: "20px"}}>
          {
            drip_accounts?.map((drip_account) => {
              return (
                <Row className="align-items-center justify-content-between" key={drip_account.id}>
                  <div className="col-auto">
                    <span className="text-success">●</span> Connected
                  </div>
                  <div className="col-auto">
                    <Button name="delete" size="sm" color="secondary" onClick={handleDelete}>Delete</Button>
                  </div>
                </Row>
              )
            })
          }
        </div>}
      </CardFooter>
    </Card>
    </>
  )
}
